import "@arco-design/web-react/es/DatePicker/style";
import _DatePicker from "@arco-design/web-react/es/DatePicker";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
const {
  RangePicker
} = _DatePicker;
export function SelectRangeDate({
  value,
  onChange,
  showTime = {
    defaultValue: ['00:00', '24:00'],
    format: 'HH:mm'
  },
  ...rest
}) {
  return /*#__PURE__*/React.createElement(RangePicker, _extends({
    style: {
      width: '100%'
    },
    value: value,
    showTime: showTime,
    onChange: onChange
  }, rest));
}